import Stage from './stage-store';
import { observable, computed } from 'mobx';
import {
  getFileForNoteNumber,
  lookup } from '../utils/chord-builder';
import {
  getRandomInt } from '../utils/game-helpers';

class SingleStore {
  possibleTunings = [-1.0, -0.5, 0.5, 1.0];
  @observable stages = [];
  @observable currentStage = null;
  passThresh = 3;
  @computed get total() {
    return this.stages.reduce( (acc, stage) => {
      if (stage.correct !== null) {
        acc++;
      }
      return acc;
    }, 0);
  }
  @computed get numberCorrect() {
    return this.stages.reduce( (acc, stage) => {
      if (stage.correct === true) {
        acc++;
      }
      return acc;
    }, 0);
  }
  @computed get percent() {
    if (this.total === 0) {
      return 0;
    }
    else {
      return Math.round(this.numberCorrect /
        this.total*100);
    }
  }
  getNewStage() {
    const newStage = this.getStage();
    this.currentStage = newStage;
    this.stages.push(newStage);
    return newStage;
  }

  getStage() {
    //note 75 for aug chord
    const base = getRandomInt(36, 75);
    const file = getFileForNoteNumber(base);
    const letter = lookup[parseInt(base % 12, 10)];
    const chosenOffset = this.possibleTunings[Math.floor(Math.random()*
      this.possibleTunings.length)];
    return new Stage([file],[chosenOffset],letter);
  }
}
export const observableSingleStore = new SingleStore();



// WEBPACK FOOTER //
// ./src/stores/single-store.js